import { render, staticRenderFns } from "./OTP2FAContent.vue?vue&type=template&id=db38c44a&scoped=true"
import script from "./OTP2FAContent.vue?vue&type=script&lang=js"
export * from "./OTP2FAContent.vue?vue&type=script&lang=js"
import style0 from "./OTP2FAContent.vue?vue&type=style&index=0&id=db38c44a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db38c44a",
  null
  
)

export default component.exports